import styled from "styled-components/macro"
import SpecsImage from "./SpecsImage"
import StylePicker from "./StylePicker"
import { useEffect } from "react"
import gsap from "gsap"
import { useStore } from "@state/store"

const SpecsSection = ({ unitData }) => {
  const contentControls = useStore((s) => s.contentControls)

  useEffect(() => {
    gsap.to(".specs", {
      autoAlpha: contentControls?.index === 2 ? 1 : 0,
      duration: 0.6,
      ease: "power3.inOut",
    })
  }, [contentControls])

  return (
    <Wrapper className="specs">
      <SpecsImage unitData={unitData} />
      <StylePicker unitData={unitData} />
    </Wrapper>
  )
}

export default SpecsSection

const Wrapper = styled.div`
  pointer-events: all;
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  background-color: transparent;
  justify-content: center;
  align-items: center;
`
